import { createFileRoute } from '@tanstack/react-router'
import { JournalListPage } from '../../../features/accounting/journal-list-page'
import { journalSearchSchema } from '../../../features/accounting/search'

export const Route = createFileRoute('/_app/journal-entries/')({
  validateSearch: journalSearchSchema,
  component: JournalListPage,
})
